<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('factoring cases')"
      :columns="columns"
      :column_search="true"
      resource_url="/factoring/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="bulk_process">
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("bulk process") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <details-modal ref="details_modal" />
    <factoring-modal ref="factoring_modal" @success="refresh" />
    <bulk-modal ref="bulk_modal" @success="refresh" />
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  put,
  download,
  get,
  error_message,
  success_message,
  format_currency,
} from "@/utils";
import FactoringModal from "./factoring_modal/Index.vue";
import BulkModal from "./bulk_modal/Index.vue";
import DetailsModal from "./details_modal/Index.vue";
import moment from "moment";

export default {
  name: "FactoringsDatatable",
  components: { GenericTable, FactoringModal, DetailsModal, BulkModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("dpi"),
          name: "settings.dpi",
          searchable: true,
          data: (row) => {
            return row.settings.dpi || "";
          },
        },
        {
          title: v.$t("nit"),
          name: "settings.nit",
          searchable: true,
          data: (row) => {
            return row.settings.nit || "";
          },
        },
        {
          title: v.$t("info"),
          searchable: false,
          data: (row) => {
            let r = "";
            if (row.execute_sat) {
              let icon = `<span class="icon has-text-warning"><i class="fa fa-clock-o"></i>`;
              if (row.settings.sat_info && row.settings.sat_info.extracted_data)
                icon = `<span class="icon has-text-success"><i class="fa fa-check"></i>`;
              r += `<span class="tag">
                      ${icon}
                      </span> <span>${v.$t("sat info extracted")}</span>
                    </span>`;

              if (row.settings.sat_info && row.settings.sat_info.extracted_nit)
                r += `<span class="tag">
                      <span class="icon has-text-primary"><i class="fa fa-check"></i>
                      </span> <span>${v.$t("nit from sat extracted")}</span>
                    </span>`;

              icon = `<span class="icon has-text-warning"><i class="fa fa-clock-o"></i>`;
              if (row.settings.sat_info && row.settings.sat_info.file_location)
                icon = `<span class="icon has-text-success"><i class="fa fa-check"></i>`;
              r += `<span class="tag">
                      ${icon}
                      </span> <span>${v.$t("rtu printing")}</span>
                    </span>`;
            }

            if (row.execute_sirc) {
              let icon = `<span class="icon has-text-warning"><i class="fa fa-clock-o"></i>`;
              if (
                row.is_sib_executed
                // row.settings.wealth_status_info &&
                // row.settings.wealth_status_info.file_location
              ) {
                icon = `<span class="icon has-text-success"><i class="fa fa-check"></i>`;
              }
              r += `<span class="tag">
                      ${icon}
                      </span> <span>${v.$t("execute sirc")}</span>
                    </span>`;
            }

            if (row.execute_wealth_status) {
              let icon = `<span class="icon has-text-warning"><i class="fa fa-clock-o"></i>`;
              if (
                row.is_wealth_status_executed
                // row.settings.wealth_status_info &&
                // row.settings.wealth_status_info.file_location
              ) {
                icon = `<span class="icon has-text-success"><i class="fa fa-check"></i>`;
              }
              r += `<span class="tag">
                      ${icon}
                      </span> <span>${v.$t("execute wealth status")}</span>
                    </span>`;
            }

            if (
              row.settings &&
              row.settings.errors &&
              row.settings.errors.length
            ) {
              r += `<span class="tag is-danger" data-tooltip="${v.$t(
                "see details for further information"
              )}">
                      <span class="icon"><i class="fa fa-exclamation-triangle"></i>
                      </span> <span>${v.$t("has errors")}</span>
                    </span>`;
            }

            return r;
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "name",
        //   searchable: true,
        //   width: "70%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.factoring_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.details_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete factoring case?"),
                    v,
                    () => {
                      del("/factoring", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ];
            if (row.execute_sat) {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("execute sat (data)"),
                icon: "fa fa-angle-right",
                icon_class: "is-small has-text-primary",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  put("/factoring/execute-sat", { uuid: uuid, type: "data" })
                    .then(() => {
                      success_message(
                        v.$t(
                          "sat data is being extracted, please wait a couple minutes"
                        )
                      );
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("execute sat (file)"),
                icon: "fa fa-angle-right",
                icon_class: "is-small has-text-success",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  put("/factoring/execute-sat", { uuid: uuid, type: "file" })
                    .then(() => {
                      success_message(
                        v.$t(
                          "sat rtu file is being generated, please wait a couple minutes"
                        )
                      );
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            if (row.execute_sirc) {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("execute sirc"),
                icon: "fa fa-angle-right",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  put("/factoring/execute-sirc", { uuid: uuid })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            if (row.execute_wealth_status) {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("execute wealth status"),
                icon: "fa fa-angle-right",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$root.loader(true);
                  put("/factoring/execute-wealth-status", { uuid: uuid })
                    .then(() => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              });
            }

            if (
              row.settings.wealth_status_info &&
              row.settings.wealth_status_info.file_location
            ) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download wealth status"),
                icon: "fa fa-download",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  download(
                    `/factoring/download-wealth-status?uuid=${uuid}`,
                    `${row.name}-${moment().format("YYYYMMDDHHmmss")}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            if (row.settings.sirc_file) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download sirc pdf"),
                icon: "fa fa-download",
                icon_class: "is-small has-text-warning",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  download(
                    `/factoring/download-sirc-pdf?uuid=${uuid}`,
                    `${row.name}-${moment().format("YYYYMMDDHHmmss")}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            if (row.settings.sat_info && row.settings.sat_info.file_location) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download rtu"),
                icon: "fa fa-download",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  download(
                    `/factoring/download-rtu?uuid=${uuid}`,
                    `${row.name}-${moment().format("YYYYMMDDHHmmss")}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            if (!row.settings.nit) {
              btns.unshift({
                args: { uuid: row.uuid },
                tooltip: v.$t("complete nit"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  put("/factoring/complete-nit", { uuid: uuid })
                    .then((rspns) => {
                      if (rspns) {
                        v.refresh();
                      } else {
                        success_message(
                          v.$t(
                            "the process is still searching on sat platform, please wait a few minutes"
                          )
                        );
                      }
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.factoring_modal.show_modal();
    },
    bulk_process() {
      let v = this;
      v.$refs.bulk_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
